import React from "react";
import Bullet from "../../components/Bullet/Bullet2";

const TermsPos = () => {
  return (
    <div className="terms2">
      <div className="terms2-and-conditions">
        <div className="terms2-and-conditions-body2">
          <main>
            <section className="terms2-and-conditions-body2-section">
              <h5>1. Validity Period</h5>
              <p>
                This Statement of Compliance shall remain valid for a period of twenty-four (24) months from the date on the Certification issued by Nigeria Inter-Bank Settlement System Plc ("NIBSS") to the Terminal/Application Owner. Upon expiry, re-certification will be required to maintain compliance status.
              </p>
            </section>

            <section className="terms2-and-conditions-body2-section">
              <h5>2. Scope and Conditions of Approval</h5>
              <p>
                This certification is granted exclusively in relation to the specific component(s) and associated specifications that were tested and approved by NIBSS and as documented in the issued Certificate.
              </p>
            </section>

            <section className="terms2-and-conditions-body2-section">
              <h5>3. Regulatory Basis</h5>
              <p>
                This Statement of Compliance confirms that the certified component(s)/specifications have met the minimum requirements as stipulated under the Central Bank of Nigeria (CBN) Guidelines on the Operations of Electronic Payment Channels in Nigeria, as well as other relevant CBN regulations or directives in force at the time of certification.
              </p>
            </section>

            <section className="terms2-and-conditions-body2-section">
              <h5>4. Consistency and Integrity of Certified Components</h5>
              <p>
                Any modification, enhancement, update, or variation—whether hardware or software—to the tested components or specifications must be promptly reported in writing to NIBSS. Such changes shall be subject to re-evaluation and re-certification before deployment. Unauthorized deployment of modified components shall render this Statement of Compliance and Certificate void with respect to those components.
              </p>
              <p>
                Throughout the validity period of this Statement, the Terminal and/or Application Owner shall ensure that all certified terminals and applications are substantially identical in material design and functionality to the samples submitted for certification.
              </p>
              <p>
                Any changes that result in a material difference in behavior or functionality, as compared to the previously assessed specifications, shall constitute a major modification and will trigger a mandatory re-certification and approval process. Failure to comply shall render this Statement of Compliance and Certificate void.
              </p>
            </section>

            <section className="terms2-and-conditions-body2-section">
              <h5>5. Market Suitability and Business Operation</h5>
              <p>
                This Statement of Compliance certifies the identified device and/or application as suitable for use within the Nigerian market. However, this document does not grant independent rights to conduct payment processing operations.
              </p>
              <p>
                The Terminal/Application Owner must partner with licensed banks and/or Payment Terminal Service Providers (PTSPs) authorized to operate within the Nigerian payments ecosystem for any business activity involving the certified components and/or operate in accordance with the license granted to the Terminal/Application Owner by the CBN.
              </p>
            </section>

            <section className="terms2-and-conditions-body2-section">
              <h5>6. Disclaimer of Endorsement and Limitation of Liability</h5>
              <p>
                This Statement of Compliance and the Certificate issued by NIBSS shall not be construed as an endorsement, guarantee, or warranty—express or implied—by NIBSS regarding:
              </p>
              <ul>
                <li className="agreements">
                  <Bullet />
                  <p>The fitness for a particular purpose.</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>Performance or commercial viability of the device/application or its components.</p>
                </li>
                <li className="agreements">
                  <Bullet />
                  <p>Non-infringement of third-party rights.</p>
                </li>
              </ul>
              <p>
                NIBSS expressly disclaims any liability for damages, losses, or claims arising from the deployment, use, or malfunction of the certified device/application or its components. The Terminal/Application Owner shall be solely and fully responsible for all obligations, liabilities, and consequences arising from the use of the certified device/application or its components in processing transactions.
              </p>
            </section>

            <section className="terms2-and-conditions-body2-section">
              <h5>7. Compliance with Deployment and Business Models</h5>
              <p>
                All deployment, operational management, and business models involving the certified component(s) must strictly conform to applicable regulatory and compliance frameworks, including those issued by the CBN and NIBSS from time to time.
              </p>
            </section>

            <section className="terms2-and-conditions-body2-section">
              <h5>8. Platform Integrity and Cross-Deployment Restrictions</h5>
              <p>
                The certified application shall not be deployed on any terminal or device that has not been separately certified by NIBSS. Cross-deployment on uncertified platforms is strictly prohibited.
              </p>
              <p>
                NIBSS shall bear no responsibility or liability for data integrity issues, performance anomalies, or operational failures arising from unauthorized deployments or configurations that deviate from those certified.
              </p>
            </section>

            <section className="terms2-and-conditions-body2-section">
              <h5>9. Customization and Post-Certification Changes</h5>
              <p>
                The Terminal/Application Owner agrees that the application, device and its components, once certified, must remain unaltered and uncustomized during deployment. Any customization, update, patch, or modification—regardless of scope—shall require prior evaluation and re-certification by NIBSS.
              </p>
              <p>
                Failure to comply with this requirement shall render this Statement of Compliance and Certificate void.
              </p>
            </section>
          </main>
        </div>
      </div>
    </div>
  );
};

export default TermsPos;
